<template>
  <div class="heads noSel">
    <div class="headerWrap">
      <div class="logo" @click="goLinks('/')">
        <!-- <div class="logoName">零距离</div>
        <div class="logoDev">Zero Distance</div>-->
        <img src="../../assets/images/logo.png" alt />
      </div>
      <div class="navWrap">
        <div
          class="li"
          v-for="(tab,index) in navLi"
          :class="{avt:tab.path==$route.path}"
          :key="index"
          @click="navTable(index,tab.path)"
        >{{tab.name}}</div>
      </div>
      <div class="headRingt">
        <!-- <div class="more" @click="isHole=true">
					<img src="../../assets/images/more.svg"> <span>帮助&nbsp;></span>
        </div>-->
        <div class="headTx" v-if="user.username" @click="isUse=!isUse">
          <img src="../../assets/images/avatar.png" alt />
          <div class="opList" v-if="isUse">
            <ul>
              <div class="iconsj"></div>
              <li class="avt">
                <span>设置</span>
              </li>
              <li v-if="user.zs==9">
                <span>卖家1号</span>
              </li>
              <li @click.stop="outLogin">
                <span>退出登录</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="ul" v-else>
          <div class="li login" @click="backLogin()">登录</div>
          <div class="li reg" @click="goReg">注册</div>
        </div>
      </div>
    </div>
    <!-- 背景 -->
    <div class="pop_bg" v-if="loginStaie.isShowLogin"></div>
    <!-- 登陆弹出 -->
    <div class="loginPop" id="loginWrap" v-if="loginStaie.isShowLogin">
      <div class="popWrap">
        <div class="icon" @click="colPop">
          <img src="../../assets/images/close.svg" />
        </div>
        <div class="popTab" id="login" v-if="!isSeReg">
          <ul class="clear-fix">
            <li style="width: 100% !important;">
              <a>账号登录</a>
            </li>
            <!-- <li :class="{avt:loginIndex==0}" @click="seletWx">
							<a>微信登录</a>
            </li>-->
            <!-- <li :class="{avt:loginIndex==1}" @click="seletPhone">
							<a>账号登录</a>
            </li>-->
          </ul>
        </div>
        <div class="popTab" id="bindLogin" v-if="isSeReg">
          <ul class="clear-fix">
            <li style="width: 100% !important;">
              <a>微信注册</a>
            </li>
          </ul>
        </div>
        <div class="popBox semllLonin" v-if="loginIndex==0">
          <div class="popCode" id="qrcode" ref="qrCodeUrl">
            <vue-qr
              :text="downloadData.url"
              :margin="0"
              colorDark="#000000"
              colorLight="#fff"
              :logoSrc="downloadData.icon"
              :logoScale="0.1"
              :size="200"
            ></vue-qr>
          </div>
          <div class="tips">
            <p>请使用微信扫码二维码登录</p>
          </div>
        </div>
        <div class="popBox phoneLogin" v-if="loginIndex==1">
          <div class="popTs">
            <img src="../../assets/images/res.png" />
          </div>
          <form class="layui-form">
            <div class="layui-input-inline">
              <input
                type="text"
                name="account"
                id="phone"
                placeholder="请输入手机号"
                class="layui-input"
                v-model="loginList.username"
              />
            </div>
            <div class="layui-input-inline paswordPop">
              <input
                type="password"
                name="password"
                id="password"
                placeholder="请输入密码"
                class="layui-input"
                v-model="loginList.password"
              />
              <span class="noPwd" @click="commonShow('fwd')">忘记密码</span>
            </div>
            <div class="layui-input-inline login-btn">
              <div class="layui-btn" id="loginBtn" @click="login">登录</div>
              <div class="popError clear-fix loginErr" style="display: none;">
                <span></span>
                <div class="err">
                  <img src="../../assets/images/err.svg" />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="linkPop phoneLogin">
          <a href="javascript:void(0);" class="goRegister" @click="goReg">注册</a>
        </div>
        <!-- <div class="linkPop">
					<a href="javascript:void(0);">微信注册</a>
        </div>-->
      </div>
    </div>
    <!-- 注册 -->
    <div class="pop_bg" v-if="isReg"></div>
    <div class="loginPop regPopWraps" id="loginopt" v-if="isReg">
      <div class="popWrap">
        <div class="icon" @click="colPop">
          <img src="../../assets/images/close.svg" />
        </div>
        <div class="popTab">
          <ul class="clear-fix">
            <li style="width: 100% !important;">
              <a>手机注册</a>
            </li>
            <!-- <li :class="{avt:loginIndex==0}" @click="seletWx">
							<a>微信注册</a>
            </li>-->
            <!-- <li :class="{avt:loginIndex==1}" @click="seletPhone">
							<a>手机注册</a>
            </li>-->
          </ul>
        </div>
        <div class="popBox semllLonin" v-if="loginIndex==0">
          <div class="popCode" id="qrcode" ref="qrCodeUrl" v-show="iscodeShow">
            <vue-qr
              :text="downloadData.url"
              :margin="0"
              colorDark="#000000"
              colorLight="#fff"
              :logoSrc="downloadData.icon"
              :logoScale="0.1"
              :size="200"
            ></vue-qr>
          </div>
          <div class="weixTx" v-if="!isCheck&&!iscodeShow">
            <img src="../../assets/images/weixinTx.png" alt />
            <p>点击注册</p>
          </div>
          <div class="weixTx curs" v-if="isCheck&&!iscodeShow" @click="iscodeShow=true">
            <img src="../../assets/images/weixinTx1.png" alt />
            <p>点击注册</p>
          </div>
          <div class="checkbox-wrap" v-show="!iscodeShow">
            <label class="check-c" :class="{check_cd:isCheck}" for="Useragreement">
              <input type="checkbox" id="Useragreement" @click="CheckReg" class="check-c" />我已阅读并接受
              <a
                href="https://zc.510jl.com/#/UserHelp"
                target="_blank"
                class="main-link-color"
              >用户协议和隐私政策</a>
            </label>
          </div>
          <div class="verify-tips-text verify" v-show="!iscodeShow">
            <span v-show="!isCheckTis">请勾选</span>
          </div>
          <div class="tips">
            <p>请使用微信扫码二维码注册</p>
          </div>
        </div>
        <div class="popBox" v-if="loginIndex==1">
          <div class="popTs">
            <img src="../../assets/images/res.png" />
          </div>
          <form class="layui-form">
            <div class="layui-input-inline" id="iptPhone">
              <input
                type="text"
                name="phone"
                id="mobile"
                placeholder="请输入手机号"
                class="layui-input"
                v-model="regList.phone"
              />
            </div>
            <div class="layui-input-inline" id="iptPhone">
              <input
                type="password"
                name="password"
                id="password"
                placeholder="请输入密码"
                class="layui-input"
                v-model="regList.password"
              />
            </div>
            <!-- <div class="layui-input-inline" id="bindPhone" style="display: none;">
							<p>您的手机号为：<span>136****3010</span></p>
            </div>-->
            <div class="layui-input-inline">
              <input
                class="codes layui-input"
                id="code"
                type="text"
                name="code"
                placeholder="验证码"
                v-model="regList.validateCode"
              />
              <input
                type="button"
                class="btnCode icons"
                :disabled="isDisabled"
                :class="{ isCode: isDisabled }"
                v-model="codeCont"
                @click="scenCode('reg')"
              />
            </div>
            <div class="checkbox-wrap">
              <label class="check-c" :class="{check_cd:isCheckTwo}" for="Useragreement">
                <input type="checkbox" id="Useragreement" @click="CheckRegs" class="check-c" />我已阅读并接受
                <a
                  href="https://zc.510jl.com/#/UserHelp"
                  target="_blank"
                  class="main-link-color"
                >用户协议和隐私政策</a>
              </label>
            </div>
            <div class="verify-tips-text verify">
              <span v-show="!isCheckTisTwo">请勾选</span>
            </div>
            <div class="layui-input-inline login-btn">
              <div id="phoneBtns" class="layui-btn" @click="reg">下一步</div>
              <div class="popError clear-fix loginErr" style="display: none;">
                <span></span>
                <div class="err">
                  <img src="../../assets/images/err.svg" />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="linkPop goLogin">
          <a href="javascript:void(0);" @click="backLogin()">返回登录</a>
        </div>
      </div>
    </div>

    <!-- 手机验证 -->
    <div class="pop_bg" v-if="isCommom"></div>
    <div class="loginPop" id="loginopt" v-if="isCommom">
      <div class="popWrap">
        <div class="icon" @click="isCommom=false">
          <img src="../../assets/images/close.svg" />
        </div>
        <div class="popTab">
          <ul class="clear-fix">
            <li style="width: 100% !important;">
              <a href="javascript:void(0);" id="phoneTitle">{{commonTitle}}</a>
            </li>
          </ul>
        </div>
        <div class="popBox">
          <div class="popTs">
            <img src="../../assets/images/res.png" />
          </div>
          <form class="layui-form">
            <div class="layui-input-inline" id="iptPhone">
              <input
                type="text"
                name="phone"
                id="mobile"
                placeholder="请输入手机号"
                class="layui-input"
                v-model="commonList.phone"
              />
            </div>
            <div class="layui-input-inline" id="bindPhone" style="display: none;">
              <p>
                您的手机号为：
                <span>136****3010</span>
              </p>
            </div>
            <div class="layui-input-inline">
              <input
                class="codes layui-input"
                id="code"
                type="text"
                name="code"
                placeholder="验证码"
                v-model="commonList.validateCode"
              />
              <input
                type="button"
                class="btnCode icons"
                :disabled="isDisabled"
                :class="{ isCode: isDisabled }"
                v-model="codeCont"
                @click="scenCode(commIndex)"
              />
            </div>
            <div class="layui-input-inline login-btn">
              <div class="layui-btn" @click="commonFun">下一步</div>
              <div class="popError clear-fix loginErr" style="display: none;">
                <span></span>
                <div class="err">
                  <img src="../../assets/images/err.svg" />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="linkPop goLogin">
          <a href="javascript:void(0);" @click="backLogin()">返回登录</a>
        </div>
      </div>
    </div>
    <!-- 手机关联 -->
    <div class="pop_bg" v-if="isAss"></div>
    <div class="loginPop" id="accountAssWrap" v-if="isAss">
      <div class="popWrap">
        <div class="icon" @click="isAss=false">
          <img src="../../assets/images/close.svg" />
        </div>
        <div class="popTab">
          <ul class="clear-fix">
            <li style="width: 100% !important;">
              <a href="javascript:void(0);">账号关联</a>
            </li>
          </ul>
        </div>
        <div class="popBox">
          <div class="popTs">
            <img src="../../assets/images/error.png" />
          </div>
          <div class="text">
            <p>该手机号已注册</p>
            <p style="margin-top: 10px;">请关联此账号或者更换手机</p>
          </div>
          <div class="layui-input-inline login-btn">
            <button type="button" class="layui-btn paddimg0" @click="goAss()">关联账号</button>
          </div>
          <div class="layui-input-inline login-btn paddimg0 upPhone">
            <button
              type="button"
              class="layui-btn"
              id="upMobile"
              @click="commonShow('wxBind')"
            >更换手机号</button>
          </div>
        </div>
        <div class="linkPop goLogin">
          <a href="javascript:void(0);" @click="backLogin()">返回登录</a>
        </div>
      </div>
    </div>
    <!-- 手机关联过 -->
    <div class="pop_bg" v-if="qAss"></div>
    <div class="loginPop" id="accountAssWrap" v-if="qAss">
      <div class="popWrap">
        <div class="icon" @click="qAss=false">
          <img src="../../assets/images/close.svg" />
        </div>
        <div class="popTab">
          <ul class="clear-fix">
            <li style="width: 100% !important;">
              <a href="javascript:void(0);">手机号绑定</a>
            </li>
          </ul>
        </div>
        <div class="popBox">
          <div class="popTs">
            <img src="../../assets/images/error.png" />
          </div>
          <div class="text">
            <p>该手机号已在平台绑定过微信</p>
            <p style="margin-top: 10px;">请更换手机号或使用该手机绑定的微信扫码登录</p>
          </div>
          <div class="layui-input-inline login-btn">
            <button type="button" class="layui-btn paddimg0" @click="commonShow('wxBind')">更换手机号</button>
          </div>
        </div>
        <div class="linkPop goLogin">
          <a href="javascript:void(0);" @click="backLogin()">返回登录</a>
        </div>
      </div>
    </div>
    <!-- 设置密码 -->
    <div class="pop_bg" v-if="isSetPwd"></div>
    <div class="loginPop" id="setPwdWrap" v-if="isSetPwd">
      <div class="popWrap">
        <div class="icon" @click="isSetPwd=false">
          <img src="../../assets/images/close.svg" />
        </div>
        <div class="popTab">
          <ul class="clear-fix">
            <li style="width: 100% !important;">
              <a href="javascript:void(0);">{{setPadCont.tit}}</a>
            </li>
          </ul>
        </div>
        <div class="popBox">
          <div class="popTs">
            <img src="../../assets/images/res.png" />
          </div>
          <form class="layui-form">
            <div class="layui-input-inline">
              <input
                type="password"
                id="setPwd"
                :placeholder="setPadCont.po"
                class="layui-input"
                v-model="setPwdList.password"
              />
            </div>
            <div class="layui-input-inline login-btn">
              <div class="layui-btn" @click="setFun()">完成</div>
              <div class="popError clear-fix loginErr" style="display: none;">
                <span></span>
                <div class="err">
                  <img src="../../assets/images/err.svg" />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="linkPop goLogin">
          <a href="javascript:void(0);" @click="backLogin()">返回登录</a>
        </div>
      </div>
    </div>
    <div class="holePop" v-if="isHole">
      <div class="headTi">
        联系我们
        <div class="icon" @click="isHole=false;">
          <img src="../../assets/images/close.svg" />
        </div>
      </div>
      <div class="lex">系统咨询QQ群</div>
      <div class="code">
        <img src="../../assets/images/codeSp.png" alt />
      </div>
      <div class="ft">
        <div class="leq">QQ群名：跨境零距离</div>
        <div class="des">QQ群号：1003134481</div>
        <div class="dexs" @click="isFeedbac=true;isHole=false">意见反馈</div>
      </div>
    </div>
    <div class="pop_bg" v-if="isFeedbac"></div>
    <div class="feedbackPop" v-if="isFeedbac">
      <div class="feedbac">
        <div class="icon" @click="isFeedbac=false">
          <img src="../../assets/images/close.svg" />
        </div>
        <div class="title">意见反馈</div>
        <div class="textCont">
          <div class="name">*问题描述：</div>
          <div class="tex">
            <textarea
              v-model="feedbackLi.content"
              placeholder="请输入问题描述"
              name
              id
              cols="30"
              rows="10"
            ></textarea>
          </div>
        </div>
        <!-- <div class="textCont">
					<div class="name">上传图片：</div>
					<div class="tex upload">
						<el-upload
						class="upload-demo"
						 accept=".jpg, .png"
						action = "http://120.78.89.173:8080/SysApi/sys/oss/upload"
						:on-preview="handlePreview"
						:on-remove="handleRemove"
						:limit='4'
						list-type="picture">
						<div class="odPik">
							+
						</div>
						</el-upload>
						<div class="odPik" v-for="(item,index) in fileList" :key="index"><img :src="item.url" alt=""></div>
						<div class="dev">文件必须小于 10MB，接受的格式为 *.png、*.jpg，最多上传四张</div>
					</div>
        </div>-->
        <div class="textCont">
          <div class="name">联系方式：</div>
          <div class="tex">
            <input v-model="feedbackLi.contract" type="text" placeholder="请输入邮件、手机号码或QQ号码任意一种联系方式" />
          </div>
        </div>
        <div class="sBtn" @click="feedbackSave">提交反馈</div>
      </div>
    </div>
  </div>
</template>
<script>
import vueQr from "vue-qr";
// import qs from 'qs'
export default {
  name: "heads",
  data: function() {
    return {
      isCheckTwo: false,
      isCheckTisTwo: true,
      isCheckTis: true,
      iscodeShow: false,
      isCheck: false,
      fileList: [],
      qAss: false,
      loginIndex: 1,
      downloadData: {
        url: "",
        icon: require("../../assets/images/logoCode.png")
      },
      navIndex: 0,
      isFeedbac: false,
      navLi: [
        {
          name: "首页",
          path: "/"
        },
        {
          name: "模拟注册",
          path: "/VirtualReg"
        }
        // {
        // 	name:"课程",
        // 	path:'/course'
        // },
        // {
        // 	name:"亚马逊卖家后台模拟",
        // 	path:'/VirtualAdmin'
        // },
        // {
        // 	name:"亚马逊头条",
        // 	path:'/Article'
        // },
      ],
      re: "",
      isSeReg: false,
      isAss: false,
      interval: null,
      wxUuid: null,
      isHole: false,
      isUse: false,
      isSetPwd: false,
      isCommom: false,
      isDisabled: false,
      isReg: false,
      regList: {
        phone: "",
        validateCode: "",
        uuid: "",
        password: "",
        sid: "",
        referrer: 1
      },
      loginList: {
        username: "",
        password: ""
      },
      commonList: {
        phone: "",
        validateCode: "",
        uuid: ""
      },
      setPwdList: {
        password: "",
        uuid: ""
      },
      commonTitle: "",
      commIndex: null,
      outTime: null,
      codeCont: "获取验证码",
      setPadCont: {
        tit: "",
        po: ""
      },
      feedbackLi: {
        contract: "",
        content: ""
      },
      countdown: 60,
      isShowLogin: ""
    };
  },
  components: {
    vueQr
  },
  watch: {
    loginStaie(newCont) {
      if (newCont.isShowLogin) {
        this.loginIndex = 1;
        clearInterval(this.interval);
        this.isCommom = false;
        this.isSetPwd = false;
        this.qAss = false;
        this.isAss = false;
        this.isReg = false;
        this.getaAcceptCode();
        this.interval = window.setInterval(this.refresh, 1000);
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loginStaie() {
      return this.$store.getters.loginStaie;
    }
  },
  mounted() {},
  created() {
    if (this.$route.query.r) {
      // console.log('111')
      this.re = this.$route.query.r;
      localStorage.setItem("r", this.$route.query.r);
    }

    this.getInfo();
    this.getaAcceptCode();
  },
  methods: {
    CheckRegs() {
      this.isCheckTwo = !this.isCheckTwo;
      if (this.isCheckTwo) {
        this.isCheckTisTwo = true;
      } else {
        this.isCheckTisTwo = false;
      }
    },
    CheckReg() {
      this.isCheck = !this.isCheck;
      if (this.isCheck) {
        this.isCheckTis = true;
      } else {
        this.isCheckTis = false;
      }
    },
    feedbackSave() {
      if (!this.feedbackLi.content) {
        this.$message({
          message: "请输入问题描述",
          duration: 1000,
          type: "error"
        });
        return;
      }
      if (!this.feedbackLi.contract) {
        this.$message({
          message: "请输入邮件、手机号码或QQ号码任意一种联系方式",
          duration: 1000,
          type: "error"
        });
        return;
      }
      // this.isFeedbac=false;
      // this.$message({
      // 	message: "反馈成功",
      // 	duration: 1000,
      // 	type:'success'
      // 	});
      //   this.feedbackLi.content=''
      // this.feedbackLi.contract=''
      this.$axios
        .post(
          this.interfaceJson.serverAddress + "/api/feedback/add",
          this.feedbackLi
        )
        .then(res => {
          let data = res.data;
          if (data.code == 0) {
            this.isFeedbac = false;
            this.$message({
              message: "反馈成功",
              duration: 1000,
              type: "success"
            });
            this.feedbackLi.content = "";
            this.feedbackLi.contract = "";
          }
        });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    backLogin() {
      this.$store.dispatch("loginState", { isShowLogin: true });
    },
    getaAcceptCode() {
      this.$axios
        .get(this.interfaceJson.serverAddress + "/api/login/acceptCode")
        .then(res => {
          let data = res.data;
          if (data.code == 0) {
            let value =
              "https://open.weixin.qq.com/connect/oauth2/authorize?" +
              "appid=wxa7f09835a7960622&" +
              "redirect_uri=" +
              this.interfaceJson.wx +
              "?uuid=" +
              data.data +
              "&" +
              "response_type=code&" +
              "scope=snsapi_base&" +
              "state=STATE#wechat_redirect";
            // console.log(value)
            this.downloadData.url = value;
            this.wxUuid = data.data;
            //启动定时器查询
          }
        });
    },
    seletWx() {
      this.getaAcceptCode();
      this.loginIndex = 0;
      this.interval = window.setInterval(this.refresh, 1000);
    },
    seletPhone() {
      this.loginIndex = 1;
      clearInterval(this.interval);
    },
    refresh() {
      this.$axios
        .get(
          this.interfaceJson.serverAddress +
            "/api/login/oauthLogin?uuid=" +
            this.wxUuid
        )
        .then(res => {
          let data = res.data;
          if (data.code == 501) {
            clearInterval(this.interval);
            //微信账号未绑定
            this.$message({
              message: "手机账号暂未绑定",
              type: "error"
            });
            this.commonList.uuid = data.accessToken;
            this.commonShow("wxBind");
            this.seletPhone();
          } else if (data.code == 0) {
            clearInterval(this.interval);
            if (this.loginStaie.isAvt == "false") {
              this.$store.dispatch("loginState", {
                isShowLogin: false,
                isAvt: "true"
              });
            } else {
              this.$store.dispatch("loginState", { isShowLogin: false });
            }
            this.isReg = false;
            localStorage.setItem("eleToken", data.data.token);
            this.getInfo();
            //  this.postToken(data.data.token)
            this.$message({
              message: "微信登录成功",
              duration: 1000,
              type: "success"
            });
            //扫码登录成功
          } else if (data.code == 502) {
            console.log("正在等待扫码....");
            //waiting 正在扫码授权 waiting
          } else if (data.code == 500) {
            //服务器异常
            clearInterval(this.interval);
          }
        });
    },
    navTable(e, path) {
      this.navIndex = e;
      this.goLinks(path);
    },
    // postToken(e){
    // 	this.$axios
    // 	.post('http://510jl.com/SysApi/api/login/syncLogin?token='+e)
    // 	.then(res => {
    // 		let data=res.data;
    // 		if(data.code==0){
    // 		}

    // 	});
    // 	this.$axios
    // 	.post('http://zc.510jl.com/SysApi/api/login/syncLogin?token='+e)
    // 	.then(res => {
    // 		let data=res.data;
    // 		if(data.code==0){
    // 		}

    // 	});

    // },
    outLogin() {
      localStorage.clear();
      sessionStorage.clear();
      this.$store.dispatch("clearCurrentState");
      this.isUse = false;
      localStorage.setItem("r", this.re);
    },
    goReg() {
      this.isCheckTis = true;
      this.iscodeShow = false;
      this.isCheck = false;
      this.loginIndex = 1;
      this.isReg = true;
      clearInterval(this.interval);
      if (this.loginStaie.isAvt == "false") {
        this.$store.dispatch("loginState", {
          isShowLogin: false,
          isAvt: "true"
        });
      } else {
        this.$store.dispatch("loginState", { isShowLogin: false });
      }
      this.getaAcceptCode();
      this.interval = window.setInterval(this.refresh, 1000);
      this.isDisabled = false;
      this.codeCont = "获取验证码";
      clearInterval(this.outTime);
      this.outTime = null;
    },

    colPop() {
      if (this.loginStaie.isAvt == "false") {
        this.$store.dispatch("loginState", {
          isShowLogin: false,
          isAvt: "true"
        });
      } else {
        this.$store.dispatch("loginState", { isShowLogin: false });
      }
      this.isReg = false;
      clearInterval(this.interval);
    },

    // 发送验证码
    scenCode(n) {
      let content = null;
      let url = "";
      if (n == "reg") {
        url = "/api/registered/sendCode";
        content = this.regList.phone;
      } else if (n == "fwd") {
        url = "/api/user/forgetPassword";
        content = this.commonList.phone;
      } else if (n == "wxBind") {
        url = "/api/user/bindValid";
        content = this.commonList;
      }
      if (
        typeof content === Object &&
        !/^1[3456789]\d{9}$/.test(content.phone)
      ) {
        this.$message({
          message: "请输入正确手机号",
          duration: 1000,
          type: "error"
        });
        return;
      }

      this.$axios
        .post(this.interfaceJson.serverAddress + url, content)
        .then(res => {
          let data = res.data;
          if (data.code == 0) {
            if (n == "reg") {
              this.regList.uuid = data.data;
            } else {
              this.commonList.uuid = data.data;
            }

            // 验证码倒计时
            if (!this.outTime) {
              this.codeCont = 60;
              this.isDisabled = true;
              this.outTime = setInterval(() => {
                if (this.codeCont > 0 && this.codeCont <= 60) {
                  this.codeCont--;
                } else {
                  this.isDisabled = false;
                  clearInterval(this.outTime);
                  this.outTime = null;
                  this.codeCont = "重新发送";
                }
              }, 1000);
            }
          }
        });
    },
    // 注册
    reg() {
      this.regList.sid = localStorage.getItem("r");
      if (!this.isCheckTwo) return;
      if (!/^1[3456789]\d{9}$/.test(this.regList.phone)) {
        this.$message({
          message: "请输入正确手机号！",
          duration: 1000,
          type: "error"
        });
        return;
      }
      if (!this.regList.validateCode) {
        this.$message({
          message: "请输入验证码！",
          duration: 1000,
          type: "error"
        });
        return;
      }
      if (!this.regList.password) {
        this.$message({
          message: "请输入密码！",
          duration: 1000,
          type: "error"
        });
        return;
      }
      this.$axios
        .post(
          this.interfaceJson.serverAddress + "/api/registered/register",
          this.regList
        )
        .then(res => {
          let data = res.data;
          if (data.code == 0) {
            // 注册成功
            this.$message({
              message: "注册成功！",
              duration: 1000,
              type: "success"
            });
            clearInterval(this.interval);
            this.isReg = false;
            localStorage.setItem("eleToken", data.data.token);
            this.getInfo();
          }
        });
    },
    commonShow(n) {
      this.qAss = false;
      this.isAss = false;
      this.isReg = false;
      this.isDisabled = false;
      this.codeCont = "获取验证码";
      clearInterval(this.outTime);
      this.outTime = null;
      this.commIndex = n;
      this.isCommom = true;
      if (this.loginStaie.isAvt == "false") {
        this.$store.dispatch("loginState", {
          isShowLogin: false,
          isAvt: "true"
        });
      } else {
        this.$store.dispatch("loginState", { isShowLogin: false });
      }
      clearInterval(this.interval);
      if (this.commIndex == "fwd") {
        this.commonTitle = "忘记密码";
        this.setPadCont.tit = "设置密码";
        this.setPadCont.po = "请设置登录密码，不少于6位";
      }
      if (this.commIndex == 1) {
        this.commonTitle = "修改密码";
      }
      if (this.commIndex == "wxBind") {
        this.commonTitle = "手机号绑定";
        this.setPadCont.tit = "登录密码";
        this.setPadCont.po = "请输入登录密码";
      }
      if (this.commIndex == "fwds") {
        this.commonTitle = "手机号绑定";
        this.setPadCont.tit = "设置密码";
        this.setPadCont.po = "请设置登录密码，不少于6位";
      }
    },
    // 公共接口
    commonFun() {
      let url = "";
      if (this.commIndex == "fwd") {
        url = "/api/user/resetPasswordToken";
      }
      if (this.commIndex == "wxBind") {
        url = "/api/user/commitValid";
      }
      this.$axios
        .post(this.interfaceJson.serverAddress + url, this.commonList)
        .then(res => {
          let data = res.data;
          if (data.code == 0) {
            this.isCommom = false;
            this.isSetPwd = true;
            this.setPwdList.uuid = data.data;
          } else if (data.code == 501) {
            this.isCommom = false;
            this.setPwdList.uuid = data.uuid;
            // 新账号绑定
            this.isSetPwd = true;
          } else if (data.code == 502) {
            this.isCommom = false;
            this.commIndex = "fwds";
            this.setPadCont.tit = "设置密码";
            this.setPadCont.po = "请设置登录密码，不少于6位";
            this.setPwdList.uuid = data.uuid;
            // 老账号绑定
            this.isAss = true;
          } else if (data.code == 503) {
            // 老账号并且已经绑定微信号
            this.isCommom = false;
            this.qAss = true;
          }
        });
    },
    goAss() {
      this.isAss = false;
      this.isSetPwd = true;
      this.commIndex = "fwds";
      this.setPadCont.tit = "设置密码";
      this.setPadCont.po = "请设置登录密码，不少于6位";
    },
    // 登录
    login() {
      if (!/^1[3456789]\d{9}$/.test(this.loginList.username)) {
        this.$message({
          message: "请输入正确手机号！",
          type: "error"
        });
        return;
      }
      if (!this.loginList.password) {
        this.$message({
          message: "请输入密码！",
          duration: 1000,
          type: "error"
        });
        return;
      }
      this.$axios
        .post(
          this.interfaceJson.serverAddress + "/api/login/login",
          this.loginList
        )
        .then(res => {
          let data = res.data;
          if (data.code == 0) {
            // 注册成功
            this.$message({
              message: "登录成功",
              duration: 1000,
              type: "success"
            });
            clearInterval(this.interval);
            if (this.loginStaie.isAvt == "false") {
              this.$store.dispatch("loginState", {
                isShowLogin: false,
                isAvt: "true"
              });
            } else {
              this.$store.dispatch("loginState", { isShowLogin: false });
            }
            localStorage.setItem("eleToken", data.data.token);
            this.getInfo();
            // this.postToken(data.data.token)
          }
        });
    },
    //   设置密码
    setFun() {
      let url = "";
      if (this.commIndex == "wxBind" || this.commIndex == "fwds") {
        url = "/api/user/commitBind";
      } else {
        url = "/api/user/resetPassword";
      }
      if (!this.setPwdList.password) {
        this.$message({
          message: "请输入密码！",
          duration: 1000,
          type: "error"
        });
        return;
      }
      this.$axios
        .post(this.interfaceJson.serverAddress + url, this.setPwdList)
        .then(res => {
          let data = res.data;
          if (data.code == 0) {
            this.isSetPwd = false;
            localStorage.setItem("eleToken", data.data.token);
            if (this.commIndex == "wxBind") {
              this.$message({
                message: "关联成功",
                duration: 1000,
                type: "success"
              });
            } else {
              this.$message({
                message: "设置成功",
                duration: 1000,
                type: "success"
              });
            }
            this.getInfo();
          }
        });
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.outTime);
  }
};
</script>
<style lang="scss" scoped>
.feedbackPop {
  position: fixed;
  background-color: #fafafa;
  left: 50%;
  top: 50%;
  z-index: 99;
  width: 450px;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  box-sizing: border-box;
  padding: 0 26px 64px 26px;
  // text-align: center;
  .feedbac {
    position: relative;
    .icon {
      position: absolute;
      right: 0;
      top: 12px;
      cursor: pointer;
      img {
        width: 10px;
        height: 10px;
      }
    }
  }
  .sBtn {
    position: absolute;
    width: 78px;
    height: 30px;
    background: rgba(23, 138, 255, 1);
    opacity: 1;
    font-size: 12px;
    color: #fff;
    line-height: 30px;
    text-align: center;
    border-radius: 6px;
    right: 0;
    bottom: -52px;
    cursor: pointer;
  }
  .title {
    padding-top: 24px;
    margin-bottom: 17px;
    font-size: 12px;
  }
  .textCont {
    display: flex;
    margin-bottom: 10px;
    .name {
      width: 66px;
      font-size: 12px;
      line-height: 30px;
      height: 30px;
    }
    .tex {
      flex: 1;
      textarea {
        height: 122px;
        width: 100%;
        resize: none;
        outline: none;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(225, 225, 226, 1);
        opacity: 1;
        border-radius: 4px;
        box-sizing: border-box;
        font-size: 12px;
        padding: 10px;
      }
      .odPik {
        width: 47px;
        height: 47px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(225, 225, 226, 1);
        opacity: 1;
        border-radius: 2px;
        text-align: center;
        color: #e8e8e8;
        font-size: 18px;
        line-height: 47px;
        cursor: pointer;
      }
      .dev {
        height: 14px;
        font-size: 10px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 14px;
        color: rgba(146, 145, 147, 1);
        opacity: 1;
        padding-top: 4px;
      }
      input {
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(225, 225, 226, 1);
        box-sizing: border-box;
        opacity: 1;
        width: 100%;
        padding: 7px;
        border-radius: 4px;
        font-size: 12px;
        outline: none;
      }
    }
    .upload {
      display: flex;
      flex-wrap: wrap;
    }
  }
}
.holePop {
  position: fixed;
  background-color: #ffffff;
  left: 50%;
  top: 50%;
  z-index: 99;
  width: 400px;
  height: 362px;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  box-sizing: border-box;
  padding: 0 24px;
  text-align: center;
}
.headTi {
  position: relative;
  border-bottom: 1px solid #e8e8e8;
  height: 40px;
  line-height: 43px;
  font-size: 12px;
  text-align: left;
}
.holePop .lex {
  line-height: 17px;
  font-size: 12px;
  margin-top: 30px;
}
.holePop .code {
  margin-top: 20px;
}
.holePop .code img {
  width: 120px;
  height: 120px;
}
.holePop .ft {
  border-top: 1px dashed #e8e8e8;
  margin-top: 25px;
}
.holePop .ft .leq {
  margin-top: 16px;
  font-size: 12px;
}
.holePop .ft .des {
  margin-top: 5px;
  font-size: 12px;
}
.holePop .ft .dexs {
  color: #178aff;
  margin-top: 12px;
  font-size: 12px;
  cursor: pointer;
}
.headTi .icon {
  position: absolute;
  right: 0;
  top: 15px;
  width: 12px;
  height: 12px;
  cursor: pointer;
}
.headTi .icon img {
  width: 12px;
  vertical-align: top;
  height: 12px;
}
.headerWrap {
  background-color: #ffffff;
  height: 80px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 999;
  box-sizing: border-box;
}
.logo {
  text-align: center;
  margin-left: 24px;
  cursor: pointer;
  img {
    // width: 90px;
    height: 35px;
  }
}
.logo .logoName {
  font-size: 20px;
  line-height: 28px;
  // padding-top:18px;
}
.logoDev {
  height: 18px;
  border: 4px solid #fbca61;
  line-height: 18px;
  font-size: 12px;
  border-top: 0;
  padding: 0 4px;
  font-weight: 500;
}
.navWrap {
  display: flex;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.navWrap .li {
  margin-left: 30px;
  font-size: 14px;
  color: #57616c;
  height: 80px;
  line-height: 80px;
  cursor: pointer;
  position: relative;
}
.navWrap .li:first-of-type {
  margin-left: 0;
}
.navWrap .li:hover::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #178aff;
  left: 0;
  bottom: 0px;
}
.navWrap .avt {
  color: #000000;
  position: relative;
}
.navWrap .avt::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #178aff;
  left: 0;
  bottom: 0px;
}
.headRingt {
  display: flex;
  align-items: center;
  margin-right: 24px;
}
.headRingt .more {
  display: flex;
  cursor: pointer;
}
.headRingt .more img {
  width: 14px;
  height: 14px;
}
.headRingt .more span {
  font-size: 12px;
  height: 14px;
  line-height: 14px;
  margin-left: 9px;
}
.headRingt .ul {
  display: flex;
  margin-left: 40px;
}
.headRingt .ul .li {
  width: 80px;
  height: 40px;
  background-color: #f3cd70;
  border-radius: 21px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  color: #232f3e;
}
.headRingt .ul .reg {
  background-color: #ffffff;
  box-sizing: border-box;
  border: 1px solid #e1e1e2;
  margin-left: 10px;
}
.headTx {
  width: 40px;
  height: 40px;
  background-color: #f3cd70;
  border-radius: 50%;
  margin-left: 40px;
  cursor: pointer;
  position: relative;
}
.headTx img {
  width: 100%;
}

.isCode {
  background-color: #cccccc !important;
}
.layui-btn {
  text-align: center;
}

.pop_bg {
  width: 100%;
  left: 0px;
  top: 0px;
  height: 100%;
  position: fixed;
  /*    user-select: none; */
  z-index: 99;
  background-color: #000;
  opacity: 0.5;
}
.tsPop {
  position: fixed;
  background-color: #cf5d4f;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 9999999;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  border-radius: 5px;
  width: 260px;
  height: 60px;
  color: #fff;
  font-size: 14px;
  line-height: 60px;
  text-align: center;
}
.loginPop {
  position: fixed;
  background-color: #ffffff;
  left: 50%;
  top: 50%;
  z-index: 9999999;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  border-radius: 5px;
}
.popWrap {
  box-sizing: border-box;
  position: relative;
  padding: 14px 45px 0;
  width: 350px;
  height: 480px;
}
.popWrap .text {
  margin-top: 30px;
  text-align: center;
}
.popWrap .text p {
  font-size: 12px;
}
.popTab {
  border-bottom: 1px solid #e1e1e2;
}
.popTab ul li {
  float: left;
  padding: 12px 0;
  width: 50%;
  text-align: center;
  height: 12px;
  line-height: 12px;
}
.popTab ul li a {
  font-size: 12px;
  color: #929193;
  position: relative;
}
.popTab ul .avt a {
  color: #178aff;
}
.popTab ul .avt a:after {
  content: "";
  position: absolute;
  background-color: #178aff;
  height: 2px;
  width: 100%;
  bottom: -9px;
  left: 0;
}
.popCode {
  border: 1px solid #e1e1e2;
  width: 260px;
  height: 260px;
  box-sizing: border-box;
  padding: 15px 11px 13px 14px;
  margin-top: 46px;
}
.popCode img {
  width: 235px;
  height: 232px;
}
.popTs {
  margin-top: 38px;
  text-align: center;
}

.popBox .layui-form {
  margin-top: 32px;
}
.popBox .login-btn {
  padding-top: 20px;
}
.login-btn {
  cursor: pointer;
}
.popBox .layui-btn {
  width: 100%;
  background-color: #178aff;
}
.popBox .layui-input-inline {
  width: 100%;
  margin-bottom: 10px;
  position: relative;
}
.popBox .paswordPop {
  position: relative;
}
.popBox .paswordPop .noPwd {
  position: absolute;
  right: 14px;
  font-size: 12px;
  height: 12px;
  line-height: 12px;
  color: #777777;
  top: 14px;
  cursor: pointer;
  z-index: 99;
}
.popBox .paswordPop input {
  padding-right: 100px;
}
.popBox .layui-input-inline input {
  border: 1px solid #e1e1e2;
  padding-left: 16px;
}
.popBox .layui-input-inline button {
  height: 40px;
  line-height: 40px;
  border: 0;
  border-radius: 3px;
  color: #ffffff;
}
.popBox .layui-input-inline input,
.popBox .layui-form .layui-btn {
  height: 40px;
  line-height: 40px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 3px;
}
.popBox .layui-form .layui-btn {
  border: 0;
  color: #ffffff;
}
.popBox .layui-input-inline .codes,
.popBox .layui-input-inline .btnCode {
  width: 125px;
  box-sizing: border-box;
}
.popBox .layui-input-inline .codes {
  border: 1px solid #e1e1e2;
}
.loginPop .icon {
  position: absolute;
  right: 9px;
  top: 14px;
  cursor: pointer;
}
.loginPop .icon img {
  width: 10px;
  height: 10px;
}
.popBox .layui-input-inline .btnCode {
  margin-left: 10px;
  background-color: #178aff;
  color: #fff;
  border: 0;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  border-radius: 5px;
  padding-left: 0 !important;
}
.popWrap .linkPop {
  position: absolute;
  bottom: 30px;
  text-align: center;
  width: 100%;
  height: 14px;
  line-height: 14px;
  left: 0;
}
.linkPop a {
  color: #333333;
  font-size: 14px;
  cursor: pointer;
}
.tips {
  margin-top: 21px;
}
.tips p {
  font-size: 14px;
  color: #333333;
  text-align: center;
}
.popError {
  position: absolute;
  right: 0;
  top: -1px;
}
.popError .err {
  width: 12px;
  border: 1px solid #cf5d4f;
  height: 12px;
  text-align: center;
  box-sizing: border-box;
  line-height: 7px;
  border-radius: 50%;
  float: right;
}
.popError span {
  float: right;
  color: #cf5d4f;
  font-size: 12px;
  margin-left: 7px;
  line-height: 12px;
}

.popError .err img {
  width: 7px;
}
.popBox .upPhone .layui-btn {
  background-color: #ffffff;
  box-sizing: border-box;
  border: 1px solid #178aff;
  color: #333333;
}
.opList {
  background-color: #ffffff;
  border-radius: 3px;
  width: 100px;
  position: absolute;
  right: -1px;
  top: 72px;
  z-index: 9999;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
}
.opList ul {
  position: relative;
}
.opList .iconsj {
  transform: rotate(180deg);
  position: absolute;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
  top: -20px;
  right: 11px;
}
.opList ul li {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eeeeee;
  width: 100px;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.opList ul li:last-of-type {
  border-bottom: 0;
}
.opList ul li span {
  color: #333;
  font-size: 12px;
}
.goWxReg {
  margin-left: 25px;
}
.checkbox-wrap {
  font-size: 13px;
  color: #666666;
  margin-top: 15px;
}
.checkbox-wrap input[type="checkbox"] {
  opacity: 0;
  margin-right: 10px;
  vertical-align: middle;
  cursor: pointer;
}
.checkbox-wrap label {
  display: inline-block;
  vertical-align: middle;
  *vertical-align: auto;
  zoom: 1;
  *display: inline;
  cursor: pointer;
}
.check-c {
  margin-right: 10px;
  background: url(../../assets/images/checkbox.svg) no-repeat 0 0px;
  background-size: 14px;
}
.check_cd {
  margin-right: 10px;
  background: url(../../assets/images/checkboxed.svg) no-repeat 0 0px;
  background-size: 14px;
}
.main-link-color {
  color: #178aff;
  margin-left: 3px;
}
.weixTx {
  text-align: center;
  margin: 69px 0px;
}
.weixTx p {
  font-size: 13px;
  margin-top: 10px;
}
.curs {
  cursor: pointer;
}
.verify-tips-text {
  height: 12px;
}
.verify-tips-text span {
  color: #cf5d4f;
  font-size: 12px;
}
.regPopWraps .popTs {
  margin-top: 15px;
}
.regPopWraps .popBox .layui-form {
  margin-top: 15px;
}
</style>
<style>
.popCode canvas {
  width: 233px;
  height: 233px;
}
</style>
